import { SVLabeledTextProps } from '@/types/common';
import { Box, Stack, Typography } from '@mui/material';

export default function SVLabeledText({
  label,
  text,
  isPrimaryColor = false,
  isSmall = false,
  customContent,
}: SVLabeledTextProps) {
  if (!text && text !== 0 && !customContent) {
    return null;
  }

  const labelId = `label-${label}-${Math.random().toString(36).substring(2, 9)}`;

  return (
    <Stack>
      <Typography
        id={labelId}
        variant={isSmall ? 'caption' : 'body1'}
        fontWeight="bold"
        color={isPrimaryColor ? 'primary' : 'inherit'}>
        {label}
      </Typography>
      {customContent ? (
        <Box aria-labelledby={labelId}>{customContent}</Box>
      ) : (
        <Typography
          sx={{ whiteSpace: 'pre-wrap', mt: 0, overflowWrap: 'break-word' }}
          variant={isSmall ? 'caption' : 'body1'}
          aria-labelledby={labelId}>
          {text}
        </Typography>
      )}
    </Stack>
  );
}
